module.exports = __webpack_public_path__ + "static/media/icon_ia.739963db.svg";